import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import FavouriteIndicator from "./FavouriteIndicator";
import StopMarker from "@catchy/assets/svgs/stop-mono-lg.svg";
export function getStopTypeColorClass(stopType) {
  switch (stopType) {
    case "train":
      return "text-green-500";
    case "cable_car":
      return "text-red-500";
    case "ferry":
      return "text-blue-500";
    case "bus":
    default:
      return "text-orange-400";
  }
}
export default function StopRow(t0) {
  const $ = _c(22);
  const {
    distance,
    isFavourite: t1,
    stop_name,
    stop_id,
    type,
    stop_type,
    onStopSelect,
    resolveStopType
  } = t0;
  const isFavourite = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== resolveStopType || $[1] !== stop_id || $[2] !== stop_type || $[3] !== type) {
    t2 = resolveStopType ? resolveStopType({
      stop_id,
      stop_type,
      type
    }) : stop_type || type;
    $[0] = resolveStopType;
    $[1] = stop_id;
    $[2] = stop_type;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const stopType = t2;
  let t3;
  if ($[5] !== onStopSelect) {
    t3 = event => {
      if (typeof onStopSelect !== "function") {
        return;
      }
      event.preventDefault();
      onStopSelect();
    };
    $[5] = onStopSelect;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleClick = t3;
  const t4 = `/stop/${stop_id}`;
  let t5;
  if ($[7] !== isFavourite || $[8] !== stopType) {
    t5 = isFavourite ? <FavouriteIndicator /> : <StopMarker className={`${getStopTypeColorClass(stopType)} ml-[16px] mr-[16px] mt-0.5 h-[1.125rem] w-3 flex-shrink-0`} />;
    $[7] = isFavourite;
    $[8] = stopType;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== stop_name) {
    t6 = <span className="min-w-0">{stop_name}</span>;
    $[10] = stop_name;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== distance) {
    t7 = distance && <span className="shrink-0 text-right opacity-60">{distance}</span>;
    $[12] = distance;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <span className="flex min-w-0 flex-1 items-start justify-between gap-3 text-pretty">{t6}{t7}</span>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== handleClick || $[18] !== t4 || $[19] !== t5 || $[20] !== t8) {
    t9 = <Link href={t4} onClick={handleClick} className="transition-colors flex flex-nowrap items-start px-[20px] py-5 text-lg leading-tight outline-none ring-blue-500/50 duration-150 hover:bg-zinc-400/10 focus-visible:ring focus-visible:ring-inset active:bg-zinc-400/10 sm:rounded-lg">{t5}{t8}</Link>;
    $[17] = handleClick;
    $[18] = t4;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}